import { Record } from 'immutable';
import EmptyList from './EmptyList';
import PwrCloudinary from 'lib/pwr-cloudinary';

type AccessType = 'upload' | 'youtube';

const VideoRecord = Record({
  ugc_id: null,
  parent_ugc_id: null,
  subject_id: null,
  ugctype: 'Video',
  ugcsubtype: null,
  ugc_archetype: '',
  author: '',
  email: '',
  source_type: null,
  created_date: '',
  updated_date: '',
  published: null,
  url: '',
  urlSet: {},
  thumbnail_url: '',
  caption: '',
  ugc_related_content: EmptyList,
  locale: '',
  accessType: null,
  featured: false,
});

export default class Video extends VideoRecord {
  static createWithData(data) {
    const rawUrl = data.url || '';
    const accessType: AccessType = PwrCloudinary.isYoutubeVideo(rawUrl)
      ? 'youtube'
      : 'upload';

    const urlSet =
      accessType === 'youtube'
        ? PwrCloudinary.youtubeUrlSet(rawUrl)
        : PwrCloudinary.libraryVideoUrlSet(rawUrl);

    return new Video({
      ...data,
      urlSet,
      accessType,
    });
  }

  getReview() {
    return this.ugc_related_content.find(ugc => ugc.ugc_archetype === 'Review');
  }
}



// WEBPACK FOOTER //
// ./src/models/Video.js